// Remove extension of Navigator (and code below that uses msSaveBlob) when we're really, truly done with IE11 support
declare global {
  interface Navigator {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    msSaveBlob: (blob: any, defaultName?: string) => boolean;
  }
}

export function downloadFile(contentType: string, fileName: string, fileData: Blob | null): boolean {
  let success = false;
  if (fileData) {
    const blob = new Blob([fileData], { type: contentType });
    if (typeof window.navigator.msSaveBlob !== 'undefined') {
      window.navigator.msSaveBlob(blob, fileName);
    } else {
      const URL = window.URL || window.webkitURL;
      const downloadUrl: string = URL.createObjectURL(blob);

      if (fileName) {
        const a = document.createElement('a');
        a.setAttribute('id', 'download-design-link');
        if (typeof a.download === 'undefined') {
          window.location.href = downloadUrl;
        } else {
          a.href = downloadUrl;
          a.download = fileName;
          a.click();
        }
      } else {
        window.location.href = downloadUrl;
      }
      URL.revokeObjectURL(downloadUrl);
    }
    success = true;
  }

  return success;
}
